import React, { useEffect } from 'react';
import styled from 'styled';

import { Confirm } from 'components/ui/modal';

import { connect } from 'containers/store'
import { SharedActionCreators, sharedActionCreators } from 'containers/shared';

import { GettyActionCreators, actionCreators } from 'domains/org/getty/actions';
import { GettyStore } from 'domains/org/getty/store';

import { DeleteGenericPointOfInterestRequest } from 'generated/mos/org/getty/audiomanagement';
import { GenericPointOfInterest } from 'generated/mos/org/getty/audio'

import { getResolvedValue } from 'helpers/linkables'
import { pick } from 'helpers/core'
import { Status, statusSelector } from 'helpers/status';

import { genericPointOfInterestSchema } from '../../../schemas/generic-point-of-interest'

type ActionProps =
  Pick<GettyActionCreators, 'gettyDeleteGenericPointOfInterestRequest'> &
  Pick<SharedActionCreators, 'toastNotification'>;

type ConnectedProps = Pick<GettyStore['getty'], 'genericPointOfInterestDelete' | 'genericPointOfInterestUpdate'>;

type DirectProps = {
  readonly historyPush: (id: string) => void;
  readonly projectId: string;
  readonly pointOfInterest: GenericPointOfInterest.Entity | undefined;
  readonly moodId?: string;
  readonly onCancel: () => void;
};
type Props = ActionProps & ConnectedProps & DirectProps;

const GenericPointOfInterestDeleteView = (props: Props) => {
  const {
    historyPush,
    projectId,
    gettyDeleteGenericPointOfInterestRequest,
    toastNotification,
    genericPointOfInterestDelete,
    genericPointOfInterestUpdate,
    onCancel,
    moodId,
    pointOfInterest
  } = props

  const payload: DeleteGenericPointOfInterestRequest.Entity = {
    ...DeleteGenericPointOfInterestRequest.defaults,
    genericPointOfInterestRef: pointOfInterest && GenericPointOfInterest.mustRef(pointOfInterest.ref)
  }

  const pointOfInterestName = pointOfInterest && genericPointOfInterestSchema.title.read(pointOfInterest.title)

  const modalMessage = (
    <>
      <p>Are you sure you want to permanently delete "{pointOfInterestName}"?</p>
    </>
  )

  const onConfirmDelete = () => {
    gettyDeleteGenericPointOfInterestRequest(payload)
    historyPush(`/project/${projectId}/mood/${moodId}`)
  }

  useEffect(() => {
    if (genericPointOfInterestDelete.status === Status.Failed) {
      toastNotification({
        type: 'error',
        text: 'Could not delete point of interest',
      });
    }
  }, [genericPointOfInterestDelete.status]) // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <Confirm
      title="Delete point of interest?"
      onClose={onCancel}
      message={modalMessage}
      confirmLabel="Delete"
      onConfirm={onConfirmDelete}
      danger
    />
  );
};

export const GenericPointOfInterestDelete = connect<ConnectedProps, ActionProps, DirectProps, GettyStore, GettyActionCreators>(
  (store) => pick(store.getty, 'genericPointOfInterestDelete', 'genericPointOfInterestUpdate'),
  {
    ...pick(actionCreators, 'gettyDeleteGenericPointOfInterestRequest'),
    ...pick(sharedActionCreators, 'toastNotification')
  }
)(GenericPointOfInterestDeleteView)
